import { nextTick } from 'vue';

import Utils from "./utils-service.js";
import Vehicle from "./vehicle-service.js";
import Driver from "./driver-service.js";
import Disaster from "./disaster-service.js";
import Home from "./home-service.js";
import Pet from "./pet-service.js";
import Renters from "./renters-service.js";
import Recv from "./recv-service.js";
import RTQ from "./rtq-service.js";
import Poll from "./poll-service.js";
import { initAddressSearch, verifyAddress } from "../../../address-search-v3.js";
import moment from 'moment';
import store from "../store.js";
import { throwError } from "../errors";

var iconic = IconicJS();

export default class Funnel {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.servicesMap = {
            'Funnel': Funnel,
            'Vehicle': Vehicle,
            'Driver': Driver,
            'Home': Home,
            'Pet': Pet,
            'Renters': Renters,
            'Recv': Recv,
            'Disaster': Disaster,
            'RTQ': RTQ
        };
        this.hasCachedRules = false;
    }

    testConsoleFxn(msg) {
        console.log(msg);
    }

    registerModalHook($vc, func) {
        const attr = 'data-modal-uid';
        const dElems = document.querySelectorAll(`[${attr}]`);
        if (!Utils.isObjEmpty(dElems)) {
            for (let i = 0; i < dElems.length; i++) {
                const el = dElems[i];
                const mdlUid = el.getAttribute(attr);

                const handler = (e) => {
                    eval(`$vc.${func}(e, mdlUid)`);
                };
                $vc.eventHandlers.set(mdlUid, handler);

                el.addEventListener('click', handler);
            }
        }
    }

    unRegisterModalHook($vc, func) {
        const attr = 'data-modal-uid';
        const dElems = document.querySelectorAll(`[${attr}]`);
        if (!Utils.isObjEmpty(dElems)) {
            for (let i = 0; i < dElems.length; i++) {
                const el = dElems[i];
                const mdlUid = el.getAttribute(attr);

                const handler = $vc.eventHandlers.get(mdlUid);
                if (handler) {
                    el.removeEventListener('click', handler);
                    $vc.eventHandlers.delete(mdlUid);
                }
            }
        }
    }

    computeNextButtonText(puid, mutate = false, page_uid) {
        const nextPage = this.ctx.getters.funnel.elements[puid];
        const currentPage = this.ctx.getters.funnel.elements[page_uid];

        let text = 'Next';

        if (!Utils.isObjEmpty(nextPage)) {

            if (!Utils.isEmpty(nextPage.button_text)) {
                text = nextPage.button_text;
            }
            if (!Utils.isObjEmpty(nextPage.button_texts)) {
                for (const bnt of nextPage.button_texts) {
                    if (this.display(bnt)) {
                        text = bnt.text;
                    }
                }
            }



        }

        if (currentPage.button_next_link) {
            //if the current page has a link for the next button -g
            text = currentPage.button_next_link.text;
        }

        if (mutate) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: puid, key: 'button_text', val: text });
        }
        return text;
    }

    computeLoadingText() {
        const puid = this.ctx.getters.active_page;
        const page = this.ctx.getters.funnel.elements[puid];
        if (!Utils.isObjEmpty(page)) {
            let text = '';
            if (!Utils.isObjEmpty(page.loading_texts)) {
                for (const ldt of page.loading_texts) {
                    if (this.display(ldt)) {
                        text = ldt.text
                    }
                }
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: puid, key: 'loading_text', val: text });
            }
        }
    }

    startPageLoading(puid = '') {
        this.computeLoadingText();
        $('.progress-bar.donut').addClass('loading-progress');

        const elems = this.ctx.getters.funnel.elements;
        let text = '';
        if (Utils.isEmpty(puid)) {
            text = 'Saving data...';
        } else if (!Utils.isEmpty(elems[puid].loading_text)) {
            text = elems[puid].loading_text;
        }

        this.ctx.commit('SET_SAVING_STATUS', true);

        if (!Utils.isEmpty(text)) {
            this.ctx.commit('SET_LOADING_STATUS', true);
            this.ctx.commit('SET_LOADING_TEXT', text);
        }
    }

    completePageLoading(puid = '') {
        let skipReset = false;

        this.ctx.commit('SET_SAVING_STATUS', false);

        if (!Utils.isEmpty(puid)) {
            const page = this.ctx.getters.funnel.elements[puid];
            if (!Utils.isObjEmpty(page)) {
                if (page.adhoc_loader_reset)
                    skipReset = true;
            }
        }

        if (!skipReset)
            this.resetLoadingState();
    }

    resetLoadingState() {
        this.ctx.commit('SET_LOADING_STATUS', false);
        this.ctx.commit('SET_LOADING_TEXT', '');
    }

    resetNotification(tplUid = '') {
        let args = {};
        if (tplUid) {
            const elems = this.ctx.getters.funnel.elements;
            args = {
                notify: elems[tplUid].text,
                notify_type: elems[tplUid].notify_type
            };
        }
        const msg = (args && args.notify) ? args.notify : '';
        const type = (args && args.notify_type) ? args.notify_type : 'bad';
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: `vx_notify_${type}`, key: 'text', val: msg });
    }

    internalErrorRedirectHandler(vc, elem = null) {
        console.log('internalErrorRedirectHandler');
        console.warn('HERE!!');
        if (elem === null)
            elem = vc.input;

        var self = vc;
        var update = { iuid: elem.uid, key: 'b_error', val: false };
        var self_fs = this;

        vc.$nextTick(function () {
            self.$store.commit('UPDATE_FUNNEL_ELEM', update);
        });

        if (localStorage && Utils.isEmpty(localStorage.getItem('zipcode'))) {
            localStorage.removeItem('zipcode');
        }
        if (elem.back_url === '/content') {
            this.startPageLoading();
        }

        vc.$router.push(elem.back_url).catch(() => { });



    }
    transitionEnter() {
        iconic.inject('.icon, .iconic')
    }
    next(puid, reload = false, isValid = false) {

        if (this.ctx.getters.funnel.elements[puid].button_next_link) {
            const nextLink = this.ctx.getters.funnel.elements[puid].button_next_link.route;
            if (nextLink) {
                window.open(nextLink, '_blank');
                return
            }
        }

        if (!isValid && !this.isValid()) {
            console.log('next not valid');
            if ($('.error:visible').filter(':first').get(0)) {
                $('.error:visible').filter(':first').get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return false;
        } else {

            // we should make an attribute for page elements for these types of functions that happen on next, something like nextFxn

            /* John M: refactor to 'beforeSave'
            if (puid === 'pg_incidents_start') {
                this.skipIncidentsDetails();
            } */
            if (puid === 'pg_coverage_select') {
                this.skipCustomizeCoverage();
            }
            // we should make an attribute for page elements for these types of functions that happen on next, something like nextFxn

            /// for when the api skips the zicode
            if (puid === 'pg_intro') {

                if (this.ctx.getters.funnel.elements.in_address_zip.value != "") {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_zipcode', key: 'page_complete', val: true });
                    this.processComplete('pg_zipcode');
                }
            }

            console.log('UPDATE_FUNNEL_ELEM page_comptete true' + puid);

            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: puid, key: 'page_complete', val: true });
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { back: false });

            this.router.push(this.ctx.getters.funnel.elements[this.getNextPUID(puid, reload)].page_route).catch(() => { });

            // this.ctx.dispatch('calculateCompletePercent')

            this.processComplete(puid);

            this.save(puid);

            // this.setMetadata();

        }
    }
    processComplete(puid) {
        if (!Utils.isEmpty(this.ctx.getters.factory.complete_pages)) {
            var complete_pages = this.ctx.getters.factory.complete_pages.slice();

            if (complete_pages.indexOf(puid) == -1) {
                complete_pages.push(puid)
                this.ctx.commit('UPDATE_FACTORY_ITEMS', { complete_pages: complete_pages })
            }
        }
    }

    getTotalPageCount(total_pages) {
        const leadGenUX = this.ctx.getters.funnel.elements.in_is_lead_gen_ux;
        let lastPuid = (!Utils.isEmpty(leadGenUX) && Utils.isTruthy(leadGenUX.value)) ? 'pg_thanks' : 'pg_rtq';
        lastPuid = this.hasRecv() ? 'pg_recv_thanks' : lastPuid;
        return total_pages.indexOf(lastPuid) >= 0 ? total_pages.indexOf(lastPuid) : total_pages.length;
    }

    reComputeTotaPagesPostQuoting(total_pages, complete_pages) {
        const uid = 'in_data_provider';
        const elems = this.ctx.getters.funnel.elements;
        if (!Utils.isObjEmpty(elems[uid])) {
            if (total_pages < complete_pages && elems[uid].value == 'canopy')
                total_pages = [...complete_pages, ...total_pages];
        }
        return total_pages;
    }

    previous(puid) {
        //TODO: add backFxn property for page elements.
        if (puid === 'pg_vehicles_summary') {
            const v = new Vehicle({ ctx: this.ctx, router: this.router });
            if (!v.validateVehicles()) {
                return false;
            }
        }

        if (puid === 'pg_drivers_summary') {
            const d = new Driver({ ctx: this.ctx, router: this.router });
            if (!d.validateDrivers()) {
                return false;
            }
        }

        this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false, back: true });


        const prevUid = this.getPrevPUID(puid);
        if (!Utils.isEmpty(prevUid)) {
            const elems = this.ctx.getters.funnel.elements;
            let route = elems[prevUid].page_route;

            if (prevUid === 'pg_intro' && elems['in_is_single_product_ux'].value) {
                //Gabriel: this will prevent the lob selection page from loading when the user clicks the back button on the browser but to get to the zipcode page we need to insert code to clear cache/session/zipcode here first and then reload to pg_zipcode
                return
            }

            this.router.push(route);

            this.fetch(prevUid);
            //John M: moved fxn call to fetch:onSuccess to make it synchronous.
            //this.setMetadata()
        }
    }

    setMetadata() {
        var active_page = this.ctx.getters.active_page;

        if (this.ctx.getters.active_page.length == 0 || !this.ctx.getters.active_page) {
            var self = this
            setTimeout(function () {
                console.log('active page not set looping setMetaData');
                self.setMetadata()
            }, 250)
            return
        }
        console.log('title');
        this.changeTitle(active_page)
        this.changeMetaDescription(active_page)
        this.changeMetaKeywords(active_page)
        if (this.ctx.getters.factory.custom_template_data && this.ctx.getters.factory.custom_template_data.sentence_case) {
            this.applySentenceCaseToPage();
        }
    }
    changeTitle(active_page) {
        var meta_title = '';
        if (this.ctx.getters.factory.custom_template_data.meta_title) {
            meta_title = this.ctx.getters.factory.custom_template_data.meta_title
        } else {
            meta_title = this.ctx.getters.funnel.elements[active_page].meta_title
        }
        // temporary while we make a catchall variable -G
        if (this.ctx.getters.funnel.elements.sc_talk_it_out.meta_title) {
            meta_title = this.ctx.getters.funnel.elements.sc_talk_it_out.meta_title
        }

        var meta_description = this.ctx.getters.funnel.elements[active_page].meta_description
        var page_title = this.ctx.getters.funnel.elements[active_page].page_title

        if (meta_description) {
            document.title = meta_title + " | " + meta_description;
        } else {
            document.title = meta_title + " | " + page_title;
        }
    }
    changeMetaDescription(active_page) {
        var meta_description = ""
        let metaDescription = document.querySelector('meta[name="description"]');

        if (this.ctx.getters.factory.custom_template_data.meta_description) {
            meta_description = this.ctx.getters.factory.custom_template_data.meta_description
        } else {
            meta_description = this.ctx.getters.funnel.elements[active_page].meta_description
        }
        // temporary while we make a catchall variable -G
        if (this.ctx.getters.funnel.elements.sc_talk_it_out.meta_description) {
            meta_description = this.ctx.getters.funnel.elements.sc_talk_it_out.meta_description
        }

        if (metaDescription) {
            // Update the content attribute if the meta tag exists
            metaDescription.setAttribute('content', meta_description);
        } else {
            // Create a new meta tag if it doesn't exist
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            metaDescription.content = meta_description;
            document.head.appendChild(metaDescription);
        }
    }
    changeMetaKeywords(active_page) {
        var meta_keywords = ""
        let metaKeywords = document.querySelector('meta[name="keywords"]');

        if (this.ctx.getters.factory.custom_template_data.meta_keywords) {
            meta_keywords = this.ctx.getters.factory.custom_template_data.meta_keywords
        } else {
            meta_keywords = this.ctx.getters.funnel.elements[active_page].meta_keywords
        }
        // temporary while we make a catchall variable -G
        if (this.ctx.getters.funnel.elements.sc_talk_it_out.meta_keywords) {
            meta_keywords = this.ctx.getters.funnel.elements.sc_talk_it_out.meta_keywords
        }

        if (metaKeywords) {
            // Update the content attribute if the meta tag exists
            metaKeywords.setAttribute('content', meta_keywords);
            console.log('assigned keywords if');
        } else {
            // Create a new meta tag if it doesn't exist
            metaKeywords = document.createElement('meta');
            metaKeywords.name = 'keywords';
            metaKeywords.content = meta_keywords;
            document.head.appendChild(metaKeywords);
            console.log('assigned keywords else');
        }
    }

    getNextPUID(puid, reload = false) {
        const seq = this.getSeq();
        const currentIndx = seq.indexOf(puid);

        const totalPages = seq.length;

        if (totalPages > currentIndx) {
            const indx = reload ? currentIndx : currentIndx + 1;
            return seq[indx];
        } else {
            return false;
        }
    }

    getPrevPUID(puid) {
        const seq = this.getSeq();
        const currentIndx = seq.indexOf(puid);

        if (currentIndx == 0 && Object.keys(this.ctx.getters.funnel.idsMap.adhoc_sequence).length > 0) {
            return seq[seq.length - 1];
        } else if (currentIndx > -1) {
            return seq[currentIndx - 1];
        } else {
            return false;
        }
    }

    getSeq() {
        const idsMap = this.ctx.getters.funnel.idsMap;
        if (!Utils.isEmpty(idsMap.adhoc_sequence)) {
            const isAdhoc = Object.keys(idsMap.adhoc_sequence).length > 0;
            return isAdhoc ? Object.keys(idsMap.adhoc_sequence) : idsMap.pages_sequence;
        }
    }

    createAdHocSeq(sourcePage, pagesObj) {
        var seq = {};
        for (const puid in pagesObj) {
            const route = pagesObj[puid];
            seq[puid] = route;
        }
        seq[sourcePage.puid] = sourcePage.route;
        this.ctx.commit('UPSERT_ADHOC_SEQ', { adhoc_sequence: seq });
    }

    destroyAdHocSeq(srcRoute) {
        const adHocSeq = this.ctx.getters.funnel.idsMap.adhoc_sequence;
        if (!Utils.isEmpty(adHocSeq) && Object.keys(adHocSeq).length > 0) {
            const seq = Object.values(adHocSeq);
            if (seq.indexOf(srcRoute) == seq.length - 1) {
                this.ctx.commit('UPSERT_ADHOC_SEQ', { adhoc_sequence: [] });
            }
        }
    }

    updateElementValues(elems) {
        Object.keys(elems).forEach((uid) => {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: elems[uid].value });
        });
    }

    isShowNextButton(puid, reload = false) {

        const nextPageId = this.getNextPUID(puid, reload);
        const showNextButton = this.ctx.getters.funnel.elements[puid].button_show_next;

        if (this.ctx.getters.funnel.elements[puid].button_show_next && this.ctx.getters.funnel.elements[puid].button_next_link) {
            //hack for linkoff on next button.
            return true
        }

        return (nextPageId && showNextButton !== false);
    }

    isShowPreviousButton(puid) {
        const prevPageId = this.getPrevPUID(puid)
        const showPrevButton = this.ctx.getters.funnel.elements[puid].button_show_prev

        if(puid == 'pg_basic_info' && this.ctx.getters.funnel.elements.in_is_single_product_ux.value) {
            return false
        }
        return (prevPageId && showPrevButton !== false);
    }

    pg_zipcode(payload) {
        console.log('Business Logic for pg_zipcode: ', payload);
        return;
    }

    pg_intro(payload) {
        console.log('Business Logic for pg_intro: ', payload);

        const elems = this.ctx.getters.funnel.elements;

        this.setOccupation(elems.in_industry.value);

        // Remove customize page if not auto or home, otherwise, attempt to add it back, if it was previously removed
        const puids = ['pg_collect_insurance_info', 'pg_current_insu_policy_start', 'pg_intro_customize'];
        if (
            payload.in_insurance_type.value.indexOf('AUTOP') == -1 &&
            payload.in_insurance_type.value.indexOf('HOME') == -1
        ) {
            this.ctx.commit('DELETE_PAGE_SEQ', puids);
        } else if (!Utils.isEmpty(elems.in_is_lead_gen_ux) && !Utils.isTruthy(elems.in_is_lead_gen_ux.value)) {
            this.addPagesToSequence('pg_basic_info', puids);
        }
        return;
    }

    setOccupation(industry, resetVal = false) {
        if (!Utils.isEmpty(industry)) {
            const uid = 'in_occupation';
            const lowDF = this.ctx.getters.factory.lowDF;
            const occupations = this.ctx.getters.factory.lowDF.occupations;
            if (!Utils.isObjEmpty(lowDF.workMap)) {
                const occupationKeys = lowDF.workMap[industry].split('|');
                var options = [];

                for (const ok of occupationKeys) {
                    options[ok] = occupations[ok];
                }
                const selectOptions = Utils.buildSelectOptions(options, true, true, true);
                if (resetVal)
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: '' });
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'options', val: selectOptions });
            } else {
                const eMsg = 'Error:- setOccupation: lowDF.workMap map is empty.';
                console.log(eMsg);
                throwError(new Error(eMsg), { "line_of_work_map": JSON.stringify(lowDF), "industry_in_context": industry });
            }
        }
    }

    hasAuto() {
        let insurance_type = this.ctx.getters.funnel.elements['in_insurance_type'].value;
        return insurance_type.includes('AUTOP');
    }

    hasHome() {
        let insurance_type = this.ctx.getters.funnel.elements['in_insurance_type'].value;
        return insurance_type.includes('HOME');
    }

    hasRenters() {
        let insurance_type = this.ctx.getters.funnel.elements['in_insurance_type'].value;
        return insurance_type.includes('RENT');
    }

    hasRecv() {
        let insurance_type = this.ctx.getters.funnel.elements['in_insurance_type'].value;
        return insurance_type.includes('RECV');
    }

    updateOccupationOptions(e, input) {
        if (e.target.value) {
            const industry = {
                in_education: this.ctx.getters.funnel.elements.in_industry.value,
                in_industry: e.target.value
            }
            const reset = (input.uid == 'in_industry');
            this.setOccupation(industry[input.uid], reset);

            if (this.hasAuto())
                this.processDOBDependentElems();
        }
    }

    processDOBDependentElems() {
        const elems = this.ctx.getters.funnel.elements;
        const dobElem = elems['in_drv_dob'];
        const minAge = elems['in_min_driving_age'].value;
        const sdpuid = 'in_is_simple_datepicker';
        const dobVal = !Utils.isObjEmpty(elems[sdpuid]) && Utils.isTruthy(elems[sdpuid].value) ? dobElem.raw_value : dobElem.value;
        const age = dobVal.indexOf('*') != -1 ? elems['in_drv_age'].value : moment().diff(dobVal, 'years');
        const isUnderAge = age < 21;
        const isStudentAge = age < 25;
        var hasStudentDisc = false;
        if (isStudentAge && ((elems['in_industry'].value == 'Student' || elems['in_student'].value == 'Yes'))) {
            hasStudentDisc = true;
        }

        var years = [];
        for (let y = minAge; y <= age; y++) {
            years.push(y);
        }
        const selectOptions = Utils.buildSelectOptions(years, true);

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_age_first_licensed', key: 'options', val: selectOptions });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_drv_is_under_age', key: 'value', val: isUnderAge });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_drv_is_student_age', key: 'value', val: isStudentAge });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_drv_has_student_discount', key: 'value', val: hasStudentDisc });
    }

    resetMasking(e, input) {
        if (Utils.isTruthy(input.basic)) {
            let elem = {};
            elem[input.uid] = Object.assign({}, this.ctx.getters.factory.driverDF.driver[input.uid]);
            this.ctx.commit('ADD_ELEMENTS', elem);
        }
    }

    pg_basic_info(payload) {
        console.log('Business Logic for pg_basic_info: ', payload);

        const phoneType = {
            value: this.ctx.getters.funnel.elements['in_phone']['type_value']
        };
        payload['in_phone_type'] = phoneType;
        delete payload['in_intro_text_block'];

        if (this.ctx.getters.funnel.elements.in_address_city.options.length > 0) {
            payload['in_address_city']['options'] = this.ctx.getters.funnel.elements.in_address_city.options
        }

        payload['in_address_city']['hidden'] = this.ctx.getters.funnel.elements.in_address_city.hidden
        payload['in_address_city']['type'] = this.ctx.getters.funnel.elements.in_address_city.type

        if (this.ctx.getters.funnel.elements['in_occupation']['value'] !== '' && !Utils.isObjEmpty(payload['in_occupation'])) {
            payload['in_occupation']['options'] = this.ctx.getters.funnel.elements['in_occupation']['options']
        }

        if (this.hasAuto())
            this.onBasicInfoChangeCheckTUPrefilPerms();

        this.setAdditionalConsentValues(payload);
        this.setConsentValueToContactChannels(payload);
        return;
    }

    onBasicInfoChangeCheckTUPrefilPerms() {
        const uid = 'in_prefil_permissions';
        const elems = this.ctx.getters.funnel.elements;
        const fctry = this.ctx.getters.factory;
        const pfsd = fctry.prefill_subject_data;

        if (!Utils.isObjEmpty(pfsd) && elems[uid].value == 'Yes') {
            const map = fctry.TUPrefillCtrlFieldsMap;
            for (const tf in map) {
                if (!Utils.isEmpty(pfsd[tf]) &&
                    !Utils.isEmpty(elems[map[tf]].value) &&
                    pfsd[tf].toLowerCase() != elems[map[tf]].value.toLowerCase()
                ) {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: 'Disqualified' });
                    this.removePrefilRelatedData();
                    break;
                }
            }
        }
    }

    setAdditionalConsentValues(payload) {
        const elems = this.ctx.getters.funnel.elements;
        if (!Utils.isObjEmpty(payload['in_consent'])) {
            const consent = elems['in_consent'];
            if (!Utils.isObjEmpty(consent.additional_consent)) {
                for (const uid of consent.additional_consent) {
                    payload[uid] = { value: elems[uid].value };
                }
            }
        }
    }

    setConsentValueToContactChannels(payload) {
        const uid = 'in_consent';
        const elems = this.ctx.getters.funnel.elements;
        if (!Utils.isObjEmpty(payload[uid])) {
            let cuids = [uid];
            if (!Utils.isObjEmpty(elems[uid].additional_consent))
                cuids = [...cuids, ...elems[uid].additional_consent];

            for (const cid of cuids) {
                const elem = elems[cid];
                if (!Utils.isObjEmpty(elem.options)) {
                    if (elem.options[0].value == elem.value[0])
                        payload[cid]['value'] = elem.contact_channels;
                }
            }
        }
    }

    zipUpdateComponentTrigger(e, input) {
        /* This currently applies to: in_same_garaged [No|Yes]; in_home_current_address_question [No|Yes];
            and in_previous_address_intl [no|intl];
         */
        let status;
        const a = ['in_same_garaged', 'in_garage_address_zip'];
        const h = ['in_home_current_address_question', 'in_current_zip'];
        const aSq = ['in_previous_address_intl', 'in_previous_address_zip'];

        switch (input.uid) {
            case a[0]:
            case h[0]:
                status = this.checkNxtBtnDisableStatus(a) || this.checkNxtBtnDisableStatus(h);
                break;
            case aSq[0]:
                status = this.checkNxtBtnDisableStatus(aSq);
                break;
            default:
                status = input.value.toLowerCase() === 'no';
        }

        this.toggleNxtBtnDisableState(status);
    }

    zipCodeValueChangeWatcher(e, input) {
        const status = input.value !== input.prev_value;
        this.toggleNxtBtnDisableState(status);
    }

    checkNxtBtnDisableStatus(fieldArr) {
        const elem = this.ctx.getters.funnel.elements;
        return (
            !Utils.isObjEmpty(elem[fieldArr[0]]) &&
            elem[fieldArr[0]].value.toLowerCase() === 'no' &&
            !Utils.isObjEmpty(elem[fieldArr[1]]) &&
            elem[fieldArr[1]].value === ''
        );
    }

    toggleNxtBtnDisableState(status) {
        this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: status });
    }

    pg_collect_insurance_info(payload) {
        console.log('Business Logic for pg_collect_insurance_info: ', payload);
        return;
    }

    pg_disaster_mobile_or_manufactured(payload) {
        console.log('Business Logic for pg_disaster_mobile_or_manufactured: ', payload);
        return;
    }

    pg_disaster_coverage_select(payload) {
        console.log('Business Logic for pg_disaster_coverage_select: ', payload);
        return;
    }

    initInsuranceInfoEventListener() {
        if (!this.ctx.getters.factory.canopy_msg_el) {
            console.log('canopy message event listener added');
            const handleCanopyMsg = (event) => {
                if (!Utils.isObjEmpty(event.data) && Object.keys(event.data).includes('canopy_event')) {
                    console.log('Message event data', event.data); // canopy_event
                    // Call functions in service files
                    if (event.data && event.data.status == 'SUCCESS') {
                        if (!Utils.isObjEmpty(event.data.pull) && event.data.pull.pull_id) {
                            // Make api request
                            const data = {
                                puid: this.ctx.getters.active_page,
                                pull_id: event.data.pull.pull_id
                            };
                            console.log(data);

                            const ps = new Poll({ ctx: this.ctx, router: this.router });
                            ps.pollInsuranceInfo(data);
                        }
                    }
                }
            };
            window.addEventListener("message", handleCanopyMsg);
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { canopy_msg_el: true });
        }

        const dpVal = this.ctx.getters.funnel.elements['in_data_provider'].value;
        if (!Utils.isEmpty(dpVal)) {
            const dpElemStatus = { dataProviderVal: dpVal, isChecked: true };
            this.initConnectionWithDataProvider(null, {}, dpElemStatus);
        }
    }

    initConnectionWithDataProvider(e = null, input = {}, args = {}) {
        let dataProviderVal = e?.target?.value || args?.dataProviderVal || '';
        let isChecked = e?.target?.checked || args?.isChecked || false;
        if (this.ctx.getters.factory.saving == true) {
            this.startPageLoading();
            this.dataSaveCheck().then(() => {
                this.completePageLoading();
                this.initDataProviderUX(dataProviderVal, isChecked);
            });
        }
        else {
            this.initDataProviderUX(dataProviderVal, isChecked);
        }
    }

    initDataProviderUX(dataProviderVal, isChecked = null) {
        const cp = 'pg_current_insu_policy';
        let puids = ['pg_current_insu_policy_start'];
        if (this.hasAuto())
            puids = [...puids, cp, 'pg_drivers_review'];
        if (this.hasHome()) {
            this.mergePuid(puids, cp);
            puids = [...puids, 'pg_home_dp_data_review'];
        }
        if (this.hasRenters())
            this.mergePuid(puids, cp);

        if (dataProviderVal == 'canopy' && !Utils.isEmpty(isChecked)) {
            this.initCanopyConnection(puids);

        } else {
            this.ctx.commit('UPDATE_PAGES_SEQ', this.ctx.getters.factory.fxp_pages_sequence);
            this.ctx.commit('ADD_ROUTES', this.ctx.getters.factory.fxp_routes);
            this.ctx.commit('DELETE_PAGE_SEQ', puids);

            const elems = this.ctx.getters.funnel.elements;
            this.setAutoPublicRecordsPermissions(dataProviderVal, elems);
            this.setHomePublicRecordsPermissions(dataProviderVal, elems);

            this.buildRoutesFromPgSeq();
        }
    }

    mergePuid(puids, puid) {
        if (!puids.includes(puid))
            puids = [...puids, puid];
    }

    initCanopyConnection(puids) {
        const fn = this;
        this.deletePrimaryXPInsuInfoCollectionPages();
        this.buildDataProviderInsuInfoCollectionXP(puids);

        const cFeats = this.ctx.getters.funnel.elements['in_canopy_features'].data;
        const handler = CanopyConnect.create(cFeats);
        handler.open();

        handler.on('exit', function () {
            handler.destroy();

            const uid = 'in_data_provider';
            fn.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: '' });
        });
    }

    setAutoPublicRecordsPermissions(dataProviderVal, elems) {
        if (this.hasAuto()) {
            const uid = 'in_prefil_permissions';
            if (!Utils.isObjEmpty(elems[uid]) && elems[uid].value != 'Disqualified') {
                let val = 'No';
                if (dataProviderVal == 'transunion')
                    val = 'Yes';
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: val });

                this.processAutoPrefillStatus(val);
            }
        }
    }

    setHomePublicRecordsPermissions(dataProviderVal, elems) {
        if (this.hasHome()) {
            const haUid = 'in_home_prefill_allowed';
            const hUid = 'in_home_prefill_permissions';
            if (!Utils.isObjEmpty(elems[haUid]) && elems[haUid].value != 'No') {
                let val = 'No';
                if (dataProviderVal == 'transunion') {
                    val = 'Yes';
                    this.addPagesToSequence('pg_home_basic_info', ['pg_home_prefill'], 'before');
                }
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: hUid, key: 'value', val: val });
                if (val == 'No')
                    this.ctx.commit('DELETE_PAGE_SEQ', ['pg_home_prefill']);
            }
        }
    }

    deletePrimaryXPInsuInfoCollectionPages() {
        //delete pages from 'pg_intro_customize' inclusive to end.
        const pgSeqTpl = this.ctx.getters.funnel.idsMap.page_sequence_lob;
        const keep = [...pgSeqTpl.intro, ...pgSeqTpl.rtq];
        keep.splice(keep.indexOf('pg_intro_customize'), 1);

        const newPgSeq = this.ctx.getters.funnel.idsMap.pages_sequence.filter((c) => {
            return keep.indexOf(c) != -1;
        });
        this.ctx.commit('UPDATE_PAGES_SEQ', newPgSeq);
    }

    buildDataProviderInsuInfoCollectionXP(puids) {
        const pgSeq = this.ctx.getters.funnel.idsMap.pages_sequence;
        let anchorPage = this.hasAuto() || this.hasHome() ? 'pg_collect_insurance_info' : '';

        let existingPuids = [];
        for (const puid of puids) {
            if (pgSeq.indexOf(puid) != -1) {
                anchorPage = puid;
                existingPuids.push(puid);
            }
        }
        puids = puids.filter(puid => !existingPuids.includes(puid));

        if (!Utils.isEmpty(anchorPage))
            this.addPagesToSequence(anchorPage, puids);

        this.buildRoutesFromPgSeq();
    }

    buildRoutesFromPgSeq() {
        const routes = [];
        const elems = this.ctx.getters.funnel.elements;
        for (const puid of this.ctx.getters.funnel.idsMap.pages_sequence) {
            if (!Utils.isObjEmpty(elems[puid])) {
                routes.push(elems[puid].page_route);
            }
        }
        this.ctx.commit('ADD_ROUTES', routes);
    }

    addPagesToSequence(anchorPage, puids, anchorType = 'after') {
        const pgSeq = this.ctx.getters.funnel.idsMap.pages_sequence;
        const pIndex = pgSeq.indexOf(puids[0]);
        if (pIndex == -1) {
            const apIndx = pgSeq.indexOf(anchorPage);
            const i = anchorType == 'after' ? apIndx + 1 : apIndx;
            for (const puid of puids.toReversed()) {
                this.ctx.commit('ADD_PAGE_SEQ', { i, puid });
            }
        }
    }

    makeChangesToCurrentPolicyFromDataProvider(e, input) {
        const puid = this.ctx.getters.active_page;
        this.computeNextButtonText(puid, true);

        let resetAnchor = null;
        if (this.hasAuto())
            resetAnchor = 'pg_drivers_review';

        if (this.hasHome())
            resetAnchor = 'pg_home_dp_data_review';

        const pgSeq = this.ctx.getters.funnel.idsMap.pages_sequence;
        let reset = true;
        if (!Utils.isEmpty(resetAnchor)) {
            if (e.target.value == 'No') {
                if (resetAnchor == 'pg_home_dp_data_review') {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_home_number_of_stories', key: 'class', val: ' s12 m4 center ' });
                }
                const indx = pgSeq.indexOf(resetAnchor);
                if (indx != -1)
                    reset = false;
            }
        } else if (this.hasRenters()) {
            resetAnchor = 'pg_renters_coverage';
            if (e.target.value == 'No' && pgSeq.indexOf(resetAnchor) == -1) {
                reset = false;
            } else if (e.target.value == 'Yes' && pgSeq.indexOf(resetAnchor) != -1) {
                reset = false;
            }
            const mkChangeReq = e.target.value == 'Yes';
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_current_insu_policy', key: 'adhoc_loader_reset', val: !mkChangeReq });
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_is_renters_info_change_requested', key: 'value', val: !mkChangeReq });

        }
        this.resetToDefaultFunnelXP(reset, pgSeq);
    }

    resetToDefaultFunnelXP(reset, pgSeq) {
        let puids = ['pg_current_insu_policy_start', 'pg_current_insu_policy'];
        puids = puids.filter(item => pgSeq.includes(item));
        if (reset) {
            this.ctx.commit('DELETE_PAGE_SEQ', puids);
            this.buildRoutesFromPgSeq();
            const factory = {
                fxp_pages_sequence: pgSeq,
                fxp_routes: this.ctx.getters.funnel.idsMap.routes,
            }

            this.ctx.commit('UPDATE_PAGES_SEQ', this.ctx.getters.factory.fxp_pages_sequence);
            this.addPagesToSequence('pg_basic_info', puids);
            this.buildRoutesFromPgSeq();

            this.ctx.commit('UPDATE_FACTORY_ITEMS', factory);
        }
    }

    toggleAdHocPageLoader(e, input) {
        const toggle = e.target.value == 'Yes';
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_current_insu_policy_start', key: 'adhoc_loader_reset', val: toggle });
    }

    pg_current_insu_policy_start(payload) {
        const uid = 'in_current_insu_policy_start';

        if (payload[uid]['value'] == 'Yes') {
            const insuUid = 'in_insurance_type';
            const elems = this.ctx.getters.funnel.elements;
            const insu = elems[uid].data[insuUid];

            payload[insuUid] = insu;
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: insuUid, key: 'value', val: insu.value });
            //TODO: if it's a home -> auto bundle we need to add a casting query param.
        }
        return;
    }

    pg_current_insu_policy(payload) {
        if (payload['in_current_insu_policy']['value'] == 'Yes') {
            this.updateElementValues(this.ctx.getters.factory.fxp_elements);
            this.disablePublicRecordsLookupPermission();
        }
        return;
    }

    disablePublicRecordsLookupPermission() {
        const qType = this.ctx.getters.funnel.elements['in_quote_type'].value;
        if (['Auto', 'Bundle'].indexOf(qType) != -1) {
            const uid = 'in_prefil_permissions';
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: 'Disqualified' });
            this.removePrefilRelatedData();
        }

        if (!this.hasRenters()) {
            if (['Homeowners', 'Bundle'].indexOf(qType) != -1) {
                const obj = { in_home_prefill_permissions: 'No', in_home_prefill_allowed: 'No' };
                for (const uid in obj) {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: obj[uid] });
                }
                this.ctx.commit('DELETE_PAGE_SEQ', ['pg_home_prefill']);
            }
        }
    }

    pg_drivers_review(payload) {
        console.log('Business Logic for pg_drivers_review: ', payload);
        return;
    }

    pg_home_dp_data_review(payload) {
        console.log('Business Logic for pg_home_dp_data_review: ', payload);
        return;
    }

    pg_intro_customize(payload) {
        console.log('Business Logic for pg_intro_customize: ', payload);

        const elems = this.ctx.getters.funnel.elements;
        const ccuid = 'in_current_city';
        if (!Utils.isObjEmpty(elems[ccuid]) && elems[ccuid].options.length > 0) {
            payload[ccuid]['options'] = elems[ccuid].options;
        }

        const gcuid = 'in_garage_city';
        if (!Utils.isObjEmpty(elems[gcuid]) && elems[gcuid].options.length > 0) {
            payload[gcuid]['options'] = elems[gcuid].options;
        }

        this.clearAddressElemValues(payload, ['in_same_garaged', 'in_home_current_address_question']);

        return;
    }

    clearAddressElemValues(payload, addrTypes, ctrlVal = 'Yes') {
        for (const uid of addrTypes) {
            if (!Utils.isObjEmpty(payload[uid]) && payload[uid].value == ctrlVal) {
                const addrType = this.ctx.getters.funnel.elements[uid].address_map;
                const addrObj = this.ctx.getters.funnel.idsMap.address_map[addrType];
                for (const af in addrObj) {
                    const iuid = addrObj[af];
                    payload[iuid].value = '';
                }
            }
        }
    }

    garageZipUpdate(e, input) {
        this.currentZipUpdate(e, input);
    }

    compareGarageToZipAddress(e, input) {
        const elems = this.ctx.getters.funnel.elements;
        const uid = 'in_alt_garage_same_as_primary';

        const pZip = elems['in_address_zip'].value;
        const pCity = elems['in_address_city'].value;
        const pAddress1 = elems['in_address1'].value.toLowerCase();

        const gZip = elems['in_garage_address_zip'].value;
        const gCity = elems['in_garage_city'].value;
        const gAddress1 = elems['in_garage_address1'].value.toLowerCase();

        let isMatch = false;
        if (gZip == pZip) {
            if (gCity == pCity) {
                if (gAddress1 == pAddress1) {
                    isMatch = true;
                }
            }
        }
        const sameAsPrimary = isMatch ? '' : 'no';
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: sameAsPrimary });
    }

    previousZipUpdate(e, input) {
        this.currentZipUpdate(e, input);
    }

    currentZipUpdate(e, input) {
        let updateZip = false
        const pattern = /\d{5}/;

        const addressMap = this.ctx.getters.funnel.idsMap.address_map[input.address_map]

        if (pattern.test(input.value)) {
            if (this.ctx.getters.funnel.elements[addressMap.address_zip].prev_value) {
                if (this.ctx.getters.funnel.elements[addressMap.address_zip].prev_value != input.value) {
                    updateZip = true
                }
            }
            else {
                updateZip = true
            }

            if (updateZip) {
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address1, key: 'value', val: "" })
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address2, key: 'value', val: "" })
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address_zip, key: 'prev_value', val: input.value })
                $("#address_zip").addClass('loading-button');
                this.updateZip(e, input, () => {
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address_city, key: 'hidden', val: false });
                    this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
                    if (input.address_map == 'garage') {
                        $("#address_zip").removeClass('loading-button');
                        setTimeout(function () {
                            $("#sc_other_garage").find('input').first().focus();
                        }, 0);
                    }
                })
            }
        }
    }

    updateZip(e, input, callback = () => { }) {

        const isZipCodePage = this.router.app._route.fullPath === '/zip-code'

        if (e.target.type === 'submit' || e.target.type === 'text') {

            const funnel = this;
            const pattern = /\d{5}/;
            const elemInput = input;
            const elem = e;

            const addressMap = this.ctx.getters.funnel.idsMap.address_map[input.address_map];

            if (pattern.test(input.value)) {
                const zipCodePuid = isZipCodePage ? 'pg_zipcode' : 'pg_basic_info';
                const reqType = this.getReqType(zipCodePuid);
                const reqData = { "zipcode": input.value };
                $.ajax({
                    type: 'POST',
                    url: '/api?req=' + reqType + '&action=zip-check&zip-uid=' + elemInput.uid + '&address-map=' + elemInput.address_map,
                    data: reqData,
                    beforeSend: function () {
                        funnel.startPageLoading(zipCodePuid);
                    },
                    success: function (ret) {
                        funnel.completePageLoading();

                        const zipUid = addressMap.address_zip
                        const stateUid = addressMap.address_state
                        const cityUid = addressMap.address_city
                        const altAddrUid = 'in_alt_address'

                        if (ret.result === "success") {
                            funnel.ctx.commit('UPDATE', { prop: 'zipcode', val: ret.zip });

                            const addrElems = funnel.handleAddressFieldsProps(ret, zipUid, cityUid, stateUid);
                            funnel.updateAddressElemsProps(addrElems);

                            callback()

                            // set localstorage for zipcode permanence. see router
                            funnel.persistZipCode();

                            if ((isZipCodePage && Utils.isObjEmpty(ret.vxrf.actions)) ||
                                (isZipCodePage && !Utils.isObjEmpty(ret.vxrf.actions) && Utils.isEmpty(ret.vxrf.actions.bypass))
                            ) {
                                funnel.next(zipCodePuid);
                            } else {
                                funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: altAddrUid, key: 'hide_zip', val: true });//added this to reset status of in_alt_address
                                funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: altAddrUid, key: 'show_error', val: false });
                            }

                            funnel.ajaxVuexResponseHandler(reqData, ret.vxrf);
                            funnel.updateAddressElemsProps(addrElems);

                            const zipReqD = { 'zip': ret.zip, 'zip_uid': elemInput.uid };
                            funnel.updateZipCodeInURL(zipReqD);
                        }
                        else {
                            const invalidMsg = 'Zip Code is not valid';
                            if (input.uid == 'in_alt_address') {
                                funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: input.error_uid, key: 'text', val: invalidMsg });
                                funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: input.uid, key: 'show_error', val: true });
                            } else {
                                const $form = funnel.prepareErrorElements();
                                $form.find('input.error').prev('label').addClass('error');
                                $form.validate().showErrors({ address_zip: invalidMsg });
                            }
                        }
                    },
                    error: function (error) {

                        const errMsg = 'A technical error occurred';
                        if (input.uid == 'in_alt_address') {
                            funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: input.error_uid, key: 'text', val: errMsg });
                            funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: input.uid, key: 'show_error', val: true });
                        } else {
                            const $form = funnel.prepareErrorElements();
                            $form.find('input.error').prev('label').addClass('error');
                            $form.validate().showErrors({ address_zip: errMsg });
                        }
                    }
                });
            }
        }

        if (isZipCodePage) {
            if (!this.isValid()) {
                $('.error:visible').filter(':first').get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
                return false;
            }
        }
    }

    handleAddressFieldsProps(ret, zipUid, cityUid, stateUid) {
        let elems = {};
        elems[zipUid] = { 'value': ret.zip };
        let cityList = [];
        if (typeof ret.city_array !== 'undefined' && ret.city_array.length > 0) {
            cityList = Utils.buildSelectOptions(ret.city_array, true);
            elems[cityUid] = { 'value': ret.city_array[0], 'options': cityList, 'type': 'select', 'hidden': false };
        } else {
            elems[cityUid] = { 'value': ret.city, 'options': cityList, 'type': 'text-inline' };
        }
        elems[stateUid] = { 'value': ret.state };
        return elems;
    }

    updateAddressElemsProps(elems) {
        for (const uid in elems) {
            for (const prop in elems[uid]) {
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: prop, val: elems[uid][prop] });
            }
        }
    }

    persistZipCode() {
        var in_address_zip = this.ctx.getters.funnel.elements["in_address_zip"].value;
        if (localStorage && (localStorage.getItem('zipcode') != in_address_zip)) {
            if (localStorage.getItem('zipcode') == undefined) {
                localStorage.setItem('zipcode', in_address_zip);
            }
        } else {
            localStorage.setItem('zipcode', null);
        }
    }

    updateZipCodeInURL(zipReqD) {
        if (zipReqD.zip_uid == 'in_alt_address') {
            let urlObj = new URL(window.location.href);
            const zipcode = urlObj.searchParams.get('zipcode');
            if (!Utils.isEmpty(zipcode) && zipcode != zipReqD.zip) {
                urlObj.searchParams.set('zipcode', zipReqD.zip);
                const newURL = urlObj.toString();
                history.replaceState({}, '', newURL);
            }
        }
    }

    validateAddress(e, input) {
        console.log(e.target);
        const funnel = this;
        const addressMap = this.ctx.getters.funnel.idsMap.address_map[input.address_map];
        const ssKey = this.ctx.getters.factory.ssKey

        try {
            $('#' + input.id).autocomplete("destroy");
            console.log("autocomplete event listener destroyed");
        }
        catch (e) {
            console.log("autocomplete event listener wasn't attached");
        }

        initAddressSearch('#' + input.id, ssKey, {
            zipcode: this.ctx.getters.funnel.elements[addressMap.address_zip].value,
            format: function (result) {
                result.label = result.street_line;
                result.value = result.street_line;
            },
            select: function (event, ui) {
                if (ui.item) {
                    const streetName = ui.item.userSubmitted ? ui.item.label : ui.item.street_line;

                    funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address1, key: 'value', val: streetName })
                }
                return false;
            }
        });
    }

    verifyStreetAddress(addressMapType, addressData) {
        const funnel = this;
        const addressMap = this.ctx.getters.funnel.idsMap.address_map[addressMapType];

        verifyAddress(addressData, function (result) {
            if (result) {
                funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address1, key: 'value', val: result.address1 })
                funnel.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: addressMap.address2, key: 'value', val: result.address2 })
                //$('#address_verified').val('Valid');
            } else {
                // funnel.ctx.commit('UPDATE_FUNNEL_ELEM', {iuid: addressMap.address1, key: 'value', val: null})
                // funnel.ctx.commit('UPDATE_FUNNEL_ELEM', {iuid: addressMap.address2, key: 'value', val: null})
                //$('#address_verified').val('None');
            }
        });
    }

    // Note: This was getting called as a blur function on the address2 fields. I've removed those fields calling this function for now, but leaving this here in case we find a use for it. - Josh 1/19/24
    reverifyAddress(e, input) {
        const addressMap = this.ctx.getters.funnel.idsMap.address_map[input.address_map];

        const street = this.ctx.getters.funnel.elements[addressMap.address1].value;
        const secondary = this.ctx.getters.funnel.elements[addressMap.address2].value;
        const city = this.ctx.getters.funnel.elements[addressMap.address_city].value;
        const state = this.ctx.getters.funnel.elements[addressMap.address_state].value;

        this.verifyStreetAddress(input.address_map, {
            street,
            secondary,
            city,
            state
        });
    }

    updateValidateAddress(e, input) {
        this.updateZip(e, input)
        this.validateAddress(e, input)
    }

    togglePrefilPermissions(e, input) {
        if (!Utils.isEmpty(input) && !Utils.isEmpty(input.value)) {
            this.processAutoPrefillStatus(input.value);
        }
    }

    processAutoPrefillStatus(permit) {
        if (['No', 'Disqualified'].indexOf(permit) != -1) {
            this.removePrefilRelatedData();
        } else {
            const pgSeq = this.ctx.getters.funnel.idsMap.pages_sequence;
            const btnText = this.ctx.getters.factory.initElements.pg_drivers_start_1.button_text;
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_drivers_start_1', key: 'button_text', val: btnText });

            const drvPrefillIndx = pgSeq.indexOf('pg_drivers_prefill');
            if (drvPrefillIndx == -1) {
                const drvStartIndx = pgSeq.indexOf('pg_drivers_start_1');
                this.ctx.commit('ADD_PAGE_SEQ', { i: drvStartIndx, puid: 'pg_drivers_prefill' });
            }
            const vehPrefillIndx = pgSeq.indexOf('pg_vehicles_prefill');
            if (vehPrefillIndx == -1) {
                const vehStartIndx = pgSeq.indexOf('pg_vehicles_start_1');
                this.ctx.commit('ADD_PAGE_SEQ', { i: vehStartIndx, puid: 'pg_vehicles_prefill' });
            }
        }
        this.buildRoutesFromPgSeq();
    }

    removePrefilRelatedData() {
        const btnText = this.ctx.getters.factory.initElements.pg_drivers_prefill.button_text;
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'pg_drivers_start_1', key: 'button_text', val: btnText });
        this.ctx.commit('DELETE_PAGE_SEQ', ['pg_drivers_prefill', 'pg_vehicles_prefill']);
    }

    showTwinButtonCardLoader(model, cnt) {
        const uid = `in_${model}_${cnt}`;
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'loading', val: true });
    }

    skipCustomizeCoverage() {
        const selectedCoverage = this.ctx.getters.funnel.elements['in_coverage_select'].value;
        console.log(selectedCoverage, 'OOOOOOOOOOOOOOOOOO');
        if (selectedCoverage) {
            console.log('delete page pg_coverage_customize');
            this.ctx.commit('DELETE_PAGE_SEQ', ['pg_coverage_customize']);
        } else {
            const pgSeq = this.ctx.getters.funnel.idsMap.pages_sequence;
            if (pgSeq.indexOf('pg_coverage_customize') == -1) {
                const index = pgSeq.indexOf('pg_coverage_select') + 1;
                console.log('add page pg_coverage_customize');
                this.ctx.commit('ADD_PAGE_SEQ', { i: index, puid: 'pg_coverage_customize' });
            }
        }
    }

    skipIncidentsDetails(e = null, input = null) {
        var $self = this;
        nextTick(function () {
            const fnl = $self.ctx.getters.funnel;
            let noIncidents = false;

            const total_accidents = parseInt(fnl.elements['in_accident_total'].value);
            const total_violations = parseInt(fnl.elements['in_violation_total'].value);
            const total_losses = parseInt(fnl.elements['in_loss_total'].value);

            // If there are no incidents, remove the incident details page from the page sequence list
            if (!total_accidents && !total_violations && !total_losses) {
                noIncidents = true;
                $self.ctx.commit('DELETE_PAGE_SEQ', ['pg_incidents']);
            } else {
                // If the incident details page was removed, add it back
                const pgSeq = $self.ctx.getters.funnel.idsMap.pages_sequence;
                if (pgSeq.indexOf('pg_incidents') == -1) {
                    const index = pgSeq.indexOf('pg_incidents_start') + 1;
                    $self.ctx.commit('ADD_PAGE_SEQ', { i: index, puid: 'pg_incidents' });
                }
            }
            $self.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_is_no_incidents', key: 'value', val: noIncidents });
            $self.buildRoutesFromPgSeq();
        });
    }

    pg_incidents_start(payload) {
        console.log('Business Logic for pg_incidents_start: ', payload);
        this.skipIncidentsDetails();
        return;
    }

    pg_incidents(payload) {
        console.log('Business Logic for pg_incidents: ', payload);
        return;
    }

    processCovCarrier(e, input) {
        const elems = this.ctx.getters.funnel.elements;
        const uids = ['in_why_no_insurance', 'in_current_carrier', 'in_carrier_previous_ninety'];
        let ccVal = this.ctx.getters.funnel.elements.in_coverage_carrier.value;

        for (const uid of uids) {
            if (!Utils.isObjEmpty(elems[uid]))
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: '' });
        }
        if (ccVal == 'no') {
            this.ctx.commit('DELETE_PAGE_SEQ', ['pg_coverage_current']);
        } else {
            this.ctx.commit('ADD_PAGE_SEQ_TO_POS', [{
                "puid": "pg_coverage_current",
                "pos": "after",
                "refUids": ["pg_coverage_carrier"]
            }]);
        }
    }

    pg_coverage_carrier(payload) {
        console.log('Business Logic for pg_coverage_carrier: ', payload);
        return;
    }

    pg_coverage_current(payload) {
        console.log('Business Logic for pg_coverage_current: ', payload);
        return;
    }

    pg_addtnl_q(payload) {
        console.log('Business Logic for pg_addtnl_q: ', payload);

        if (this.ctx.getters.active_page == 'pg_length_at_dwelling') {
            this.clearAddressElemValues(payload, ['in_previous_address_intl'], 'intl');
        }
        return;
    }

    pg_coverage_select(payload) {
        console.log('Business Logic for pg_coverage_select: ', payload);

        payload['in_is_custom_coverages'] = { value: false };

        this.setDefaultEffectiveDate('in_coverage_start_date', 8);

        return;
    }

    pg_coverage_customize(payload) {
        console.log('Business Logic for pg_coverage_customize: ', payload);

        payload['in_is_custom_coverages'] = { value: true };

        this.setDefaultEffectiveDate('in_coverage_start_date', 8);

        return;
    }

    pg_coverage_start(payload) {
        console.log('Business Logic for pg_coverage_start: ', payload);
        return;
    }

    setDefaultEffectiveDate(uid, days) {
        if (Utils.isEmpty(this.ctx.getters.funnel.elements[uid].value)) {
            let date = new Date();
            date.setDate(date.getDate() + days);
            const effectiveDate = Utils.formatDate(date);
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: effectiveDate });
        }
    }

    processRegulatoryNotice() {
        const uid = 'in_reg_notice';
        const elems = this.ctx.getters.funnel.elements;
        const covStartDate = elems['in_coverage_start_date'].value;

        if (!Utils.isEmpty(covStartDate)) {
            let isToBeBumped = this.determineCoverageBumpingStatus(elems, uid);
            const isEndOrFutureDate = this.determineEffectiveDateStatus(elems, uid, covStartDate);

            const showNotice = (elems[uid]['value'] && isToBeBumped && isEndOrFutureDate);
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_is_reg_notice_timeframe', key: 'value', val: showNotice });
        }
    }

    determineCoverageBumpingStatus(elems, uid) {
        const stateData = elems[uid]['data']['states'][elems['in_address_state'].value];
        let isToBeBumped = false;
        if (Utils.isTruthy(elems['in_is_custom_coverages'].value) && !Utils.isEmpty(stateData)) {
            const covs = Object.keys(stateData);
            for (const cov of covs) {
                const cElem = elems[`in_coverage_${cov}`];
                const covVal = cElem['options'][cElem['value']].value;
                if (stateData[cov].includes(covVal)) {
                    isToBeBumped = true;
                    break;
                }
            }
        } else {
            isToBeBumped = elems['in_coverage_select']['value'] == elems[uid]['data']['coverage_package'];
        }
        return isToBeBumped;
    }

    determineEffectiveDateStatus(elems, uid, covStartDate) {
        const tFrame = elems[uid]['data']['daterange'];
        const sDate = new Date(covStartDate);
        const eDate = new Date(tFrame[1]);

        const startDate = new Date(sDate.getFullYear(), sDate.getMonth(), sDate.getDate());
        const targetDate = new Date(eDate.getFullYear(), eDate.getMonth(), eDate.getDate());

        return startDate >= targetDate;
    }

    getPredicateYearElemDependantUids() {
        const uid = 'in_is_simple_datepicker';
        return this.ctx.getters.funnel.elements[uid].data.date_dependencies.in_home_year_built;
    }

    execYearBuiltDependenciesProcesses(e, input) {
        const depUids = this.getPredicateYearElemDependantUids();
        const currentPgIuids = this.getPageInputs(this.ctx.getters.active_page);
        this.hasCachedRules = true;
        for (let uid of depUids) {
            const elem = this.ctx.getters.funnel.elements[uid];
            if (!Utils.isEmpty(elem.value) && currentPgIuids.includes(uid)) {
                this.isValid(elem);
            }
        }
    }

    purgeJQueryCachedRules(validator) {
        const elems = this.ctx.getters.funnel.elements;
        if (this.hasCachedRules && !Utils.isObjEmpty(elems['in_is_simple_datepicker'])) {
            const depUids = this.getPredicateYearElemDependantUids();

            for (let elem of Object.values(validator.currentForm)) {
                if (depUids.includes(elem.id)) {

                    for (let attr of Object.values(elem)) {
                        let purge = false;
                        if (attr.ruleSdpmaxage !== undefined && attr.ruleSdpmaxage != $(elem).attr('maximum'))
                            purge = true

                        if (purge) {
                            attr.ruleSdpmaxage = $(elem).attr('maximum');
                            if (attr.msgSdpmaxage !== undefined)
                                attr.msgSdpmaxage = $(elem).attr('data-msg-sdpmaxage');

                            if (attr.ruleSdpminage !== undefined)
                                attr.ruleSdpminage = $(elem).attr('minimum');
                            if (attr.msgSdpminage !== undefined)
                                attr.msgSdpminage = $(elem).attr('data-msg-sdpminage');

                            this.hasCachedRules = !this.hasCachedRules;
                            this.isValid(elems[elem.id]);
                        }
                    }
                }
            }
        }
    }

    processCurrCarrierLenDependentElems(e, input) {
        let uid
        let elem = (typeof input === "object") ? input.uid : input

        switch (elem) {
            case 'in_current_carrier_length': // auto
                uid = 'in_coverage_current_continuous'
                break;

            case 'in_home_coverage_current_carrier_years': // home
                uid = 'in_home_coverage_current_continuous'
                break;
        }

        const ccContUid = uid;
        const ccContOpts = this.ctx.getters.funnel.elements[ccContUid].options.slice();
        const elemVal = (typeof e === "object") ? e.target.value : this.ctx.getters.funnel.elements[elem].value

        let disableOpt = false;
        var options = [];
        for (const opt of ccContOpts) {
            let optCp = []
            optCp["label"] = opt["label"]
            optCp["value"] = opt["value"]
            optCp["disabled"] = opt["disabled"]

            if (opt.value == elemVal) {
                disableOpt = true;
            }

            optCp['disabled'] = !disableOpt;
            options.push(optCp);
        }
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: ccContUid, key: 'options', val: options });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: ccContUid, key: 'value', val: '' });
    }

    isValid(input) {
        const $form = this.prepareErrorElements();
        // If an input element was provided, just validate that instead of the whole form.
        if (input) {
            $('label[for="' + input.id + '"]').removeClass('error');
            return $form.validate().element(document.querySelector(`[data-uid='${input.uid}']`));
        } else {
            // Check if $form is empty first
            if (Object.keys($form).length && !$form.valid()) {
                $form.find('input.error').prev('label').addClass('error');
                $form.find('select.error').prev('label').addClass('error');
                return false;
            }
            return true;
        }
    }

    prepareErrorElements() {
        // validation
        const $form = $(`#form-${this.ctx.getters.active_page}`);
        const fs = this;

        const validator = $form.validate({
            errorElement: 'small',
            errorClass: 'error',
            ignore: '',
            showErrors: function (errorMap, errorList) {
                // Call the default showErrors function
                this.defaultShowErrors();

                // Prepend "Error:" to each error message
                $.each(errorList, function (index, error) {
                    $(error.element).next('.error').html('Error: ' + error.message);
                });
            },
            errorPlacement: function (error, element) {
                let type = $(element).attr('type');
                let uid = $(element).attr('data-uid');
                let elem = fs.ctx.getters.funnel.elements[uid];
                let label = element.parent().find('label').text();

                error.text("Error: " + error.text());

                // if ($(element).attr('data-msg-farmersmultibrand') !== undefined) {
                //     //multibrand consent error
                //     const container = element.closest('.alert');
                //     const errorDiv = $('<div></div>').addClass('error-here').addClass('multibrand-error-here');
                //     container.append(errorDiv);

                //     container.find('.multibrand-error-here').append(error).attr('aria-label', error.text() + " " + label);
                //     return
                // }

                // Radios are formatted differently so make sure the error is below it.
                if (!Utils.isEmpty(elem) && Utils.isTruthy(elem.hide_error)) {
                    return true;
                } else if (type === 'radio' || type === 'checkbox' || type === 'hidden') {
                    if (element.parent().parent().parent().find('.error-here .error').length == 1) { return }

                    if (type === 'radio' && elem.type != "carrier-radio") {
                        element.closest('[role="fieldset"], fieldset').siblings('.error-here').append(error).attr('aria-label', error.text() + " " + label);

                    } else if (type === 'radio' && elem.type == "carrier-radio") {
                        element.closest('.grid').find('.error-here').append(error).attr('aria-label', error.text() + " " + label);
                    }
                    else {
                        element.parent().parent().parent().find('.error-here').append(error).attr('aria-label', error.text() + ". " + label);;
                    }
                }

                else if ($(element).hasClass('input-spinner')) {
                    // $("."+uid+"-container").addClass('error')
                    element.parent().parent().parent().parent().find('.spinner-error').append(error).attr('aria-label', error.text() + " " + label);;
                }
                else {
                    error.insertAfter(element).attr('aria-label', error.text() + " " + label);;
                }




                $(':input.error').first().focus();
            }
        });

        this.purgeJQueryCachedRules(validator);
        return $form
    }

    checkStrMatch(val) {
        return val.match(this.ctrl);
    }

    getElementsByUids(filters) {
        /* 
        const filters = [
                { prop: 'page_usage', value: 'data_provider' },
                { prop: 'page_usage', value: 'prefill' }
            ];
        */

        /* const obj = { firstName: 'Jean-Luc', lastName: 'Picard', age: 59 };
        const allowedKeys = ['firstName', 'lastName'];
        const filteredObj = Object.keys(obj)
            .filter((uid) => (!Utils.isObjEmpty(obj[uid].page_usage) && obj[uid].page_usage == 'data_provider')) //allowedKeys.includes(key))
            .reduce((acc, uid) => {
                acc[uid] = obj[uid];
                return acc;
            }, {});
        console.log(filteredObj); */ // { firstName: 'Jean-Luc', lastName: 'Picard' }

        const elems = this.ctx.getters.funnel.elements;
        const filteredObj = Object.keys(elems)
            .filter((uid) => (!Utils.isObjEmpty(elems[uid].page_usage) && elems[uid].page_usage == 'data_provider')) //allowedKeys.includes(key))
            .reduce((acc, uid) => {
                acc[uid] = elems[uid];
                return acc;
            }, {});

        return filteredObj;

        /* let filtered = {};
        for (const f of filters) {
            elems = this.ctx.getters.funnel.elements.filter(elem => elem[f.prop] === f.value);
            filtered = [...filtered, ...elems];
        }
        return filtered; */
    }

    getPageInputSeqBySuid(puid, suid) {
        var inSeq = [];
        if (!Utils.isEmpty(puid) && !Utils.isEmpty(suid)) {
            inSeq = this.ctx.getters.funnel.idsMap.pages[puid].sections[suid].inputs_sequence;
        }
        return inSeq;
    }

    getPageInputs(puid) {
        const sections = this.ctx.getters.funnel.idsMap.pages[puid].sections;
        const sIds = this.ctx.getters.funnel.idsMap.pages[puid].sections_sequence;
        var inputs = [];
        for (const sId of sIds) {
            if (inputs === undefined || inputs.length === 0) {
                inputs = sections[sId].inputs_sequence;
            } else {
                inputs = [...inputs, ...sections[sId].inputs_sequence];
            }
        }
        return inputs;
    }

    getPageInputVals(iuids) {
        const elems = this.ctx.getters.funnel.elements;
        var payload = {};
        for (const iuid of iuids) {
            payload[iuid] = { value: elems[iuid].value };
        }
        return payload;
    }

    getFunctionalPageUid(puid) {
        const page = this.ctx.getters.funnel.elements[puid];
        return page.isTemplatePage ? page.page_id : puid;
    }

    processPayload(puid, payload) {
        const page = this.ctx.getters.funnel.elements[puid];
        const service = page.vueService;
        const lib = {
            ctx: this.ctx,
            router: this.router
        }

        const funcPuid = this.getFunctionalPageUid(puid);
        try {
            console.log(`Page being saved: ${page}`);
            const srv = new this.servicesMap[service](lib);
            eval(`srv.${funcPuid}(payload)`);
        } catch (err) {
            let eMsg = `Error:- processPayload: ${err}. calling non-existent function ${funcPuid} in ${service}`
            console.log(eMsg);

            throwError(new Error(eMsg), { "payload": JSON.stringify(payload), "page": page, "lib": lib });
        }
    }

    setRawValuesAsActualValues(payload) {
        var self = this;
        Object.keys(payload).map(function (el) {
            const elem = self.ctx.getters.funnel.elements[el];
            if (!Utils.isObjEmpty(elem) && !Utils.isEmpty(elem.raw_value)) {
                payload[el].value = elem.raw_value;
                self.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: el, key: 'value', val: elem.raw_value });
            }
        });
    }

    skipElemsWithTextValue(payload) {
        const uids = this.ctx.getters.factory.textValueUids;
        for (const uid of uids) {
            if (payload[uid] !== undefined)
                delete payload[uid];
        }
    }

    // setPageAsComplete(puid, payload) {
    //     this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: puid, key: 'page_complete', val: true });
    //     const page = {
    //         page_complete: this.ctx.getters.funnel.elements[puid].page_complete
    //     }
    //     payload[puid] = page;
    // }

    beforeSave(puid) {
        const iuids = this.getPageInputs(puid);
        const payload = this.getPageInputVals(iuids);

        this.setRawValuesAsActualValues(payload);
        this.skipElemsWithTextValue(payload);
        this.processPayload(puid, payload);

        // this.setPageAsComplete(puid, payload);
        return payload;
    }

    buildPostData(puid, payload) {
        const ctrl = {
            processAction: this.getFunctionalPageUid(puid),
            puid: puid
        };
        const factory = {
            complete_pages: this.ctx.getters.factory.complete_pages,
            complete_percent: this.ctx.getters.factory.complete_percent
        };

        const saveData = { factory: factory, ctrl: ctrl, payload: payload };
        console.log('Save data: ', saveData);
        return saveData;
    }

    save(puid) {
        var payload = this.beforeSave(puid);

        const post = this.buildPostData(puid, payload);

        if (this.ctx.getters.factory.saving == true) {
            this.startPageLoading();
            this.dataSaveCheck().then(() => {
                this.completePageLoading();
                this.ctx.dispatch('save', post);
            });
        }
        else {
            this.ctx.dispatch('save', post);
        }
    }

    dataSaveCheck() {
        return new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                if (this.ctx.getters.factory.saving == false) {
                    resolve();
                    clearInterval(interval);
                }
            }, 1000);
        });
    }

    commitMutations(data) {
        const factory = this.ctx.getters.factory;
        if (Object.keys(factory).length > 0 && !Utils.isEmpty(factory.vxCommitMutations)) {
            for (const key of factory.vxMutationsSeq) {
                const mutation = factory.vxCommitMutations[key];
                if (!Utils.isObjEmpty(data[key])) {
                    this.ctx.commit(mutation, data[key]);
                }
            }
        }
        return;
    }

    ajaxVuexResponseHandler(req, res) {
        if (res != null && Object.keys(res).length > 0) {
            if (!Utils.isObjEmpty(res.data)) {
                this.commitMutations(res.data);
                //const syncExec = this.commitMutations(res.data);
                const dk = Object.keys(res.data);
                if (dk.includes('init') && dk.includes('factoryItems')) {
                    this.completePageLoading();
                }
            }

            this.actionResponseHandler(res.actions);

            if (!Utils.isObjEmpty(res.data) && !Utils.isObjEmpty(res.data.rtqReq)) {
                console.log('start polling.', res.data);
                if (!Utils.isObjEmpty(res.data.rtqReq.quote_execution_ids)) {
                    const rtq = new RTQ({ ctx: this.ctx });
                    rtq.getRatings(
                        {
                            ...{ options: res.data.rtqReq },
                            ...{ trigger_page: req.ctrl.puid }
                        });
                } else {
                    this.completePageLoading();
                }
            }

            if (!Utils.isEmpty(res.success) && res.success == true) {
                this.completePageLoading();
            }
        }
    }

    actionResponseHandler(actions) {
        if (!Utils.isObjEmpty(actions)) {

            if (!Utils.isEmpty(actions.remove_url_params)) {
                this.removeUrlParams(actions.remove_url_params);
            }

            if (!Utils.isEmpty(actions.bypass)) {
                this.next(actions.bypass.puid, false, true);
            }

            if (!Utils.isEmpty(actions.redirect)) {
                this.router.push(actions.redirect.url).catch(() => { });
            }

            if (!Utils.isEmpty(actions.exec)) {
                try {
                    const exec = actions.exec;
                    eval(`this.${exec.fxn}(exec.arg)`);
                } catch (err) {
                    let eMsg = `Error:- store: ${err}. calling non-existent function ${exec.fxn} with ${exec.arg} arg`;
                    console.log(eMsg);
                    throwError(new Error(eMsg), { "actions": JSON.stringify(actions) });
                }
            }
        }
    }

    removeUrlParams(params) {
        let url = new URL(window.location.href);
        let searchParams = new URLSearchParams(url.search);
        for (const param of params) {
            searchParams.delete(param);
        }
        url.search = searchParams.toString();
        const newURL = url.toString();
        history.replaceState({}, '', newURL);
    }

    bypassActionHandler(res) {
        if (Utils.isTruthy(this.ctx.getters.funnel.elements.in_is_single_product_ux.value)) {
            if (Utils.isObjEmpty(res.actions))
                res['actions'] = { bypass: {} };

            res.actions.bypass = { puid: 'pg_intro' };
            if (!Utils.isEmpty(res.actions.bypass)) {
                this.next(res.actions.bypass.puid, false, true);
            }
        }
    }

    fetch(puid) {
        const ctrl = {
            processAction: this.getFunctionalPageUid(puid),
            puid: puid
        };
        this.ctx.dispatch('fetch', { ctrl: ctrl });
    }

    dynamic_text_vars(input) {
        if (!Utils.isObjEmpty(input) && !Utils.isEmpty(input.dynamic_vars)) {
            var retAttr = {}
            for (const attr of Object.keys(input.dynamic_vars)) {
                var attr_template = input.dynamic_vars[attr].template
                const attr_vars = input.dynamic_vars[attr].variables

                for (const var_name of Object.keys(attr_vars)) {
                    const var_uid = input.dynamic_vars[attr].variables[var_name]
                    if (!Utils.isEmpty(this.ctx.getters.funnel.elements[var_uid].value)) {
                        attr_template = attr_template.replaceAll(var_name, this.ctx.getters.funnel.elements[var_uid].value)
                    }
                    else {
                        attr_template = attr_template.replaceAll(var_name, "")
                    }
                }

                retAttr[attr] = attr_template
            }

            return retAttr
        }

        return false
    }

    setDynamicTextVars() {
        if (this.ctx.getters.active_page) {
            var page = this.ctx.getters.active_page
        }
        else {
            return false
        }

        if (this.ctx.getters.funnel.idsMap.pages[page].sections === undefined) {
            throwError(new Error("setDynamicTextVars error: " + page + " page sections not found"));
            return false
        }

        const pgSections = this.ctx.getters.funnel.idsMap.pages[page].sections

        for (const section of Object.keys(pgSections)) {
            console.log('section', section)
            const dynVars = this.dynamic_text_vars(this.ctx.getters.funnel.elements[section])
            console.log('section dynVars', dynVars)
            if (dynVars) {
                this.mergeElemObj(section, dynVars)
            }

            const sectionElem = this.ctx.getters.funnel.idsMap.pages[page].sections[section]

            if (sectionElem) {
                for (let a = 0; sectionElem.inputs_sequence.length > a; a++) {
                    const dynVars = this.dynamic_text_vars(this.ctx.getters.funnel.elements[sectionElem.inputs_sequence[a]])
                    if (dynVars) {
                        this.mergeElemObj(sectionElem.inputs_sequence[a], dynVars)
                    }
                }
            }
        }
    }

    mergeElemObj(uid, obj) {
        for (const attr of Object.keys(obj)) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: attr, val: obj[attr] })
        }
    }

    display(input) {
        var show = true;
        if (!Utils.isObjEmpty(input)) {
            try {
                if (!Utils.isEmpty(input.display)) {
                    if (!this.displayConditionals(input.display))
                        show = false
                }
                return show;
            } catch (e) {
                console.warn('SOMETHING HAPPENED', e.message, input);
                console.warn(this.ctx.state.funnel.elements);
            }
        }
    }

    class_display(input) {
        var returnClass = false

        try {
            if (!Utils.isEmpty(input.class_display)) {
                returnClass = this.displayClassConditionals(input.class_display)
                return returnClass;
            }
        } catch (e) {
            console.warn('SOMETHING HAPPENED', e.message, input);
            console.warn(this.ctx.state.funnel.elements);
        }

    }

    displayClassConditionals(elemCond) {
        let returnClass = false

        for (const uid of Object.keys(elemCond)) {
            console.log('display_class', uid)
            for (const arrObj of elemCond[uid]) {
                const [logic] = Object.keys(arrObj.logic)

                const [operator] = Object.keys(arrObj.logic[logic])

                const condVal = arrObj.logic[logic][operator]

                var elemVal = this.ctx.getters.funnel.elements[uid][logic]

                if (elemVal === Object(elemVal) && !Array.isArray(elemVal)) {
                    elemVal = this.displayConditionals(elemVal)
                }

                const emptyDisplay = (elemVal === undefined && logic === 'display')

                if (emptyDisplay || this.displayConditionalsValueState(operator, elemVal, condVal)) {
                    let append = arrObj.append == true ? true : false
                    return { "return": arrObj.return, "append": append }
                }
            }
        }

        return returnClass
    }

    displayConditionals(elemCond) {
        let conditionsMet = false

        const checkLogic = {
            'and': (obj) => {
                if (obj.elemCondLength === obj.conditionsMetCount)
                    return true
                else if (obj.loopCount !== obj.conditionsMetCount) {
                    return 'break'
                }
                else
                    return false
            },
            'or': (obj) => {
                if (obj.conditionsMetCount > 0)
                    return true
                else
                    return false
            }
        }

        if (!Utils.isEmpty(elemCond)) {
            const logic = ('or' in elemCond) ? 'or' : 'and'

            const status = {}
            status.elemCondLength = Object.keys(elemCond).length
            status.conditionsMetCount = 0
            status.loopCount = 1

            for (const uid of Object.keys(elemCond)) {
                switch (uid) { // skip if 'and' or 'or' flag is set
                    case 'and':
                    case 'or':
                        continue
                }

                if (Utils.isObjEmpty(this.ctx.getters.funnel.elements[uid]))
                    continue;

                const elemVal = this.ctx.getters.funnel.elements[uid].value
                const [operator] = Object.keys(elemCond[uid])

                const condVal = elemCond[uid][operator]

                if (this.displayConditionalsValueState(operator, elemVal, condVal)) {
                    status.conditionsMetCount++
                    conditionsMet = checkLogic[logic](status)
                }

                if (conditionsMet === 'break') {
                    conditionsMet = false;
                    break;
                }
                else if (conditionsMet === true)
                    break

                status.loopCount++
            }
        }

        //console.log('conditionMet: ', conditionsMet)
        return conditionsMet
    }

    displayConditionalsValueState(operator, elemVal, condVal) {
        const elemValIsArray = Array.isArray(elemVal);
        const condValIsArray = Array.isArray(condVal);

        let conditionMet = false;

        switch (operator) {
            case 'eq':
            case 'ne':
            case 'eqregexp': // string to string comparision only
            case 'neregexp': // string to string comparision only
            case 'eqexact': // two array comparison only (for now)
                if (elemValIsArray && condValIsArray) {
                    const isInArrayVals = condVal.filter((val) => {
                        return new Set(elemVal).has(val)
                    })

                    if (operator == 'eq') {
                        conditionMet = isInArrayVals.length > 0
                    }

                    if (operator == 'ne') {
                        conditionMet = isInArrayVals.length == 0
                    }

                    if (operator == 'eqexact') {
                        conditionMet = isInArrayVals.length == elemVal.length
                    }
                }
                else if (elemValIsArray || condValIsArray) {
                    let arrVal, strVal = null;

                    if (elemValIsArray) {
                        arrVal = elemVal
                        strVal = condVal
                    }

                    if (condValIsArray) {
                        arrVal = condVal
                        strVal = elemVal
                    }

                    if (operator == 'eq') {
                        conditionMet = new Set(arrVal).has(strVal)
                    }

                    if (operator == 'ne') {
                        const elemValSet = new Set(arrVal).has(strVal)
                        conditionMet = !elemValSet
                    }
                }
                else {
                    let isEqual = (elemVal == condVal)

                    if (operator == 'eq') {
                        conditionMet = isEqual
                    }

                    if (operator == 'ne') {
                        conditionMet = !isEqual
                    }

                    if (operator == 'eqregexp') {
                        const re = new RegExp(condVal)
                        conditionMet = re.test(elemVal)
                    }

                    if (operator == 'neregexp') {
                        const re = new RegExp(condVal)
                        conditionMet = !re.test(elemVal)
                    }
                }

                break;
            case 'gt':
            case 'lt':
            case 'gte':
            case 'lte':
                if (operator == 'gt') {
                    conditionMet = (elemVal > condVal)
                }

                if (operator == 'lt') {
                    conditionMet = (elemVal < condVal)
                }

                if (operator == 'gte') {
                    conditionMet = (elemVal >= condVal)
                }

                if (operator == 'lte') {
                    conditionMet = (elemVal <= condVal)
                }
                break;
            case 'leneq':
            case 'lengt':
            case 'lengte':
            case 'lenlt':
            case 'lenlte':
                if (Array.isArray(elemVal)) {
                    var len = elemVal.length
                    var val = condVal
                }

                if (Array.isArray(condVal)) {
                    var len = condVal.length
                    var val = elemVal
                }

                if (operator == 'leneq' && len == val) {
                    conditionMet = true
                }

                if (operator == 'lengt' && val > len) {
                    conditionMet = true
                }

                if (operator == 'lengte' && val >= len) {
                    conditionMet = true
                }

                if (operator == 'lenlt' && val < len) {
                    conditionMet = true
                }

                if (operator == 'lenlte' && val <= len) {
                    conditionMet = true
                }

                break;
            case 'empty':
            case 'notEmpty':
            case 'notempty':
                const isEmpty = (elemVal == null || elemVal == undefined || elemVal == '' || (Array.isArray(elemVal) && elemVal.length == 0))

                if (operator == 'empty' && condVal == true) {
                    conditionMet = isEmpty
                }

                if (operator == 'empty' && condVal == false) {
                    conditionMet = !isEmpty
                }

                if (operator.toLowerCase() == 'notempty' && condVal == true) {
                    conditionMet = !isEmpty
                }

                if (operator.toLowerCase() == 'notempty' && condVal == false) {
                    conditionMet = isEmpty
                }
                break;
        }

        return conditionMet
    }

    processToggleModal(e, input) {
        if (!Utils.isObjEmpty(input.fxn.args) && !Utils.isEmpty(input.fxn.args.modelUid)) {
            this.toggleModal(input.fxn.args.modelUid);
        }
    }

    toggleModal(uid) {
        console.log('toggle modal ' + uid);
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'hidden', val: !this.ctx.getters.funnel.elements[uid].hidden });
        if (this.ctx.getters.funnel.elements[uid].hidden) {
            document.body.style.overflow = 'scroll';
        } else {
            document.body.style.overflow = 'hidden';
        }
    }
    isBundle() {
        const lobs = this.ctx.getters.funnel.elements['in_insurance_type'].value
        let bundle = false;

        if (lobs.length > 1 && lobs.indexOf("AUTOP") != -1) {
            if (lobs.indexOf('HOME') != -1 || lobs.indexOf('RENT') != -1) {
                bundle = true
            }
        }

        return bundle;
    }

    getReqType(puid) {// data.ctrl.puid
        var reqType = 'quoter';
        const page = this.ctx.getters.funnel.elements[puid];
        if (page.page_model !== undefined) {
            var reqType = page.page_model
        }
        return reqType;
    }

    fetchHomePrefill() {
        this.ctx.dispatch('fetchHomePrefill');
    }
    // WIP for checking for the existence of icons before loading them -G
    // icon(item) {
    //     if (item.icon_name) {
    //         var iconUrl = '/static/images/card-icons/' + item.icon_name.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "") + '.svg';
    //     }else{
    //         var text = item.label
    //         var iconUrl = '/static/images/card-icons/' + text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "") + '.svg'
    //     }
    //     var self = this

    //     // fsweb.readString(iconUrl).then(function(file){
    //     //     console.log('found', file);
    //     //     return file;
    //     // }).catch(function(error, file){
    //     //     console.log(error, file);
    //     //     return
    //     // });
    //     // console.log(window.location.origin+'/static/images/card-icons');

    //     // fsweb.readdir(window.location.origin+'/static/images/card-icons').then(function(files){
    //     //     console.log(files);
    //     // }).catch(function(error){
    //     //     console.log(error);
    //     // });
    // }
    checkImage(url) {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true); // Image exists
            img.onerror = () => resolve(false); // Image does not exist
            img.src = url;
        });
    }
    icon(item) {
        if (item.icon_name) {
            console.log(item.icon_name, 'image FOUND Icon name set on Element');

            return '/static/images/card-icons/' + item.icon_name.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "") + '.svg'
        } else {
            var text = item.label
            const iconUrl = '/static/images/card-icons/' + text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "") + '.svg'

            return iconUrl;
        }

    }
    static chatIframe(data, path) {
        // the five9 script is being loaded from the app.wrapper as a regular js fil because i havent found a way to add it to webpack. It's not an npm package and it doesnt expose the methods properly. 
        console.log('chat initiated');

        // default options overwritten on the custom template data
        var options = {
            "rootUrl": "https://app.five9.com/consoles/",
            "type": "chat",
            "title": "Questions? Ask an Agent.",
            "tenant": "Bindable",
            "showProfiles": false,
            "autostart": true,
            "theme": "default-theme.css",
            "surveyOptions": {
                "showComment": false,
                "requireComment": false
            },
            "fields": {
                "name": {
                    "value": "",
                    "show": true,
                    "label": "Name"
                },
                "email": {
                    "value": "",
                    "show": true,
                    "label": "Email"
                },
                "UserLocale": {
                    "value": "en",
                    "show": false
                }
            },
            "playSoundOnMessage": true,
            "allowCustomerToControlSoundPlay": true,
            "showEmailButton": true,
            "hideDuringAfterHours": true,
            "useBusinessHours": true,
            "showPrintButton": false,
            "allowUsabilityMenu": false,
            "enableCallback": false,
            "callbackList": "",
            "allowRequestLiveAgent": false
        }
        if (data.options) {
            Object.keys(data.options).map(function (i) {
                //override the default options if they exist in custom template data
                // console.log(i, data.options[i]);
                if (options[i] != data.options[i]) {
                    // console.log("default chat option: ",i, options[i]);
                    // console.log("custom chat option: ",i, data.options[i]);
                    options[i] = data.options[i];
                }
            })
        }
        options.profiles = "Chat " + (/\.loc$/.test(location.hostname) || /\enroll-five9-chat$/.test(location.hostname) ? "enroll-qa.mylifeprotected.com" : location.hostname)

        var ts = data.template_set == 'mlp' ? 'tacqu_v3' : data.template_set;
        // load custom css
        options.theme = /\.loc$/.test(location.hostname) ? "default-theme.css" : "https://" + location.hostname + "/static/stylesheets/template-set/" + ts + "/chat.css"
        console.log(options.theme);
        // initialize widget
        Five9SocialWidget.addWidget(options);
    }

    static removeChats() {
        //kill widget
        Five9SocialWidget.removeWidget()
    }
    isMobile() {
        // $large-breakpoint: 1140px;
        // $medium-breakpoint: 970px;
        // $small-breakpoint: 200px;
        // $height-breakpoint: 640px;
        // var mb = this.ctx.getters.factory.css_variables.mediumBreakpoint.replace(/\D/g,'');
        // var hb = this.ctx.getters.factory.css_variables.heightBreakpoint.replace(/\D/g,'');
        var mb = 970;
        var hb = 640;
        return this.ctx.getters.window.width < mb || this.ctx.getters.window.height < hb //using from css variables
    }
    parseHtml(html) {
        if (!html) {
            return
        }
        return html.replace(/{{(.+?)}}/g, (_, g) => {
            console.log("PARSE HTML:: " + this[g.trim()]);
            return this[g.trim()];
        });
    }

    removeZipOnBNSReq() {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        console.log('We have param BNS', params.get('bns'));
        if (!Utils.isEmpty(params.get('bns')) && localStorage.getItem('zipcode')) {
            localStorage.removeItem('zipcode');
        }
    }

    adBtnClick(e, input) {
        if (input.modal_data.click_url) {
            window.open(input.modal_data.click_url, '_blank', 'noopener, noreferrer');
        }
    }
    elementAnnouncer(input) {
        const selectAnnouncer = document.getElementById(input.id + '_announcer');
        if (selectAnnouncer && input.loading) {
            selectAnnouncer.textContent = "Dynamic element " + input.label + " loading. Please wait.";
        }
        if (selectAnnouncer && !input.loading) {
            selectAnnouncer.textContent = "Dynamic element " + input.label + " loaded. Please continue.";
        }
        console.log(selectAnnouncer);
    }

    identifyCardType(input) {
        const trimmedCardNumber = this.ctx.getters.funnel.elements[input.uid].value.replace(/\D/g, ''); // Remove non-digit characters

        if (trimmedCardNumber.startsWith('4')) {
            return 'Visa';
        } else if (/^5[1-5]/.test(trimmedCardNumber)) {
            return 'MasterCard';
        } else if ((trimmedCardNumber.startsWith('34') || trimmedCardNumber.startsWith('37'))) {
            return 'American Express';
        } else if (/^6011|^65|^64[4-9]|^647|^648|^649/.test(trimmedCardNumber)) {
            return 'Discover';
        } else if (/^3(0[0-5]|[68]|[1-9][0-9])/.test(trimmedCardNumber)) {
            return 'Diners Club';
        } else if (/^35(2[89]|[3-8][0-9])/.test(trimmedCardNumber)) {
            return 'JCB';
        } else if (trimmedCardNumber.startsWith('62')) {
            return 'UnionPay';
        } else {
            return '';
        }
    }

    static ADAbuttons() {

        setTimeout(function () {
            $('a').each(function () {
                //add titles to links 
                if (!$(this).attr('aria-label') || !$(this).attr('aria-labelledby')) {
                    var anchorText = $(this).text().trim();
                    if ($(this).attr('href')) {
                        if ($(this).attr('href').startsWith('tel:')) {
                            $(this).attr('aria-label', 'Link to Call: ' + anchorText);
                        } else {
                            $(this).attr('aria-label', 'Link to ' + anchorText);
                        }
                        if ($(this).attr('target') === ('0') || $(this).attr('target') === ('_blank')) {
                            $(this).attr('aria-label', anchorText + ' opens in new window');
                        }
                    }
                }
            });
            $('button').each(function () {
                // Check if the button or its children have text if not add a dummy element with text to it containing the button classes
                var hasText = false;
                $(this).contents().each(function () {
                    if (this.nodeType === Node.TEXT_NODE && $(this).text().trim() !== '') {
                        hasText = true;
                    }
                });

                if (!hasText) {
                    var buttonClass = $(this).attr('class') || 'no-class';
                    var srSpan = $('<span>').addClass('sr-only').text(buttonClass);
                    $(this).append(srSpan);
                }
            });

            $('.error-here').each(function () {
                // console.log(this);
                if (!$(this).attr('role')) {
                    $(this).attr('role', 'alert');
                }
            });
        }, 500)
    }
   applySentenceCaseToPage() {
        // Convert text to sentence case (capitalize first letter, rest lowercase)
        function toSentenceCase(text, node) {
            if (!text || typeof text !== 'string') return text;
            
            // Transform text to sentence case
            let transformedText = text.toLowerCase().replace(/(^\s*|[.!?]\s+)([a-z])/g, 
            (match, separator, letter) => separator + letter.toUpperCase());
            
            // Special terms dictionary with proper capitalization
            const specialTerms = {
                'zip code': 'ZIP code',
                'zip codes': 'ZIP codes',
                'zipcode': 'ZIP code',
                'zipcodes': 'ZIP codes',
                'ssn': 'SSN',
                'ein': 'EIN',
                'id': 'ID',
                'vin': 'VIN',
                'pdf': 'PDF',
                'url': 'URL',
                'usa': 'USA',
                // Company names to preserve capitalization
                'massdrive': 'MassDrive',
                'mylifeprotected': 'MyLifeProtected',
                'lincoln': 'Lincoln',
                'lincoln financial group': 'Lincoln Financial Group',
                'bindable': 'Bindable'
            };
            
            // Replace all special terms with their proper capitalization
            Object.keys(specialTerms).forEach(term => {
                const regex = new RegExp('\\b' + term + '\\b', 'gi');
                transformedText = transformedText.replace(regex, specialTerms[term]);
            });
            
            // Handle CSS overrides
            const parentEl = node.parentNode;
            if (parentEl && window.getComputedStyle) {
                const style = window.getComputedStyle(parentEl);
                if (style.textTransform === 'uppercase' || style.textTransform === 'capitalize') {
                    parentEl.style.textTransform = 'none';
                    
                    if (parentEl.tagName === 'BUTTON' || 
                        parentEl.tagName === 'LABEL' || 
                        parentEl.classList.contains('uppercase') ||
                        parentEl.classList.contains('text-uppercase')) {
                        parentEl.style.textTransform = 'none';
                    }
                }
            }
            
            return transformedText;
        }

        // Create walker to find all text nodes
        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    const parent = node.parentNode;

                    // Skip consent-related elements
                    if (parent.id && (parent.id.includes('_consent') || parent.id.includes('consent_') || parent.id === 'label_in_consent') || 
                        parent.getAttribute('data-uid') && (parent.getAttribute('data-uid').includes('_consent') || parent.getAttribute('data-uid').includes('consent_') || parent.getAttribute('data-uid') === 'in_consent_lb') ||
                        parent.getAttribute('for') && (parent.getAttribute('for').includes('_consent') || parent.getAttribute('for') === 'in_consent') ||
                        parent.getAttribute('name') && (parent.getAttribute('name').includes('_consent') || parent.getAttribute('name') === 'in_consent')) {
                        return NodeFilter.FILTER_REJECT;
                    }
                    if (parent.closest && parent.closest('[data-uid*="consent"], [id*="consent"], [for*="consent"], [name*="consent"], .consent-container')) {
                        return NodeFilter.FILTER_REJECT;
                    }

                    // Footer elements
                    if (parent.closest && 
                        (parent.closest('footer') || 
                        parent.closest('.footer') || 
                        parent.closest('[role="contentinfo"]'))) {
                        // Process links in footer, ignore other footer content
                        if (parent.nodeName === 'A' || parent.closest('a')) {
                            return NodeFilter.FILTER_ACCEPT;
                        }
                        return NodeFilter.FILTER_REJECT;
                    }
                    
                    // First, process form labels (ensure they ARE processed)
                    if (parent.nodeName === 'LABEL') {
                        // Skip labels that are consent-related
                        const forAttr = parent.getAttribute('for');
                        if (forAttr && forAttr.includes('_consent')) {
                            return NodeFilter.FILTER_REJECT;
                        }
                        return NodeFilter.FILTER_ACCEPT;
                    }
                    
                    // Skip input element values and other non-displayable text
                    if (['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'OPTION', 'SELECT'].includes(parent.nodeName) ||
                        parent.getAttribute('data-no-sentence-case') ||
                        parent.getAttribute('type') === 'radio' ||
                        parent.getAttribute('type') === 'checkbox') {
                        return NodeFilter.FILTER_REJECT;
                    }
                    
                    // Skip elements inside select/option
                    if (parent.closest && parent.closest('select, option')) {
                        return NodeFilter.FILTER_REJECT;
                    }
                    
                    // Skip elements with zip-text class
                    if ((parent.classList && parent.classList.contains('zip-text')) ||
                        (parent.closest && parent.closest('.zip-text'))) {
                        return NodeFilter.FILTER_REJECT;
                    }
                    
                    // Process non-empty text nodes
                    return node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                }
            }
        );
        
        // Process each text node
        let node;
        while (node = walker.nextNode()) {
            const original = node.textContent;
            const transformed = toSentenceCase(original, node);
            if (original !== transformed) {
                node.textContent = transformed;
            }
        }
        
        // Special pass for labels that might be missed
        const labels = document.querySelectorAll('label');
        labels.forEach(label => {
            if (!label.getAttribute('data-no-sentence-case')) {
                for (const childNode of label.childNodes) {
                    if (childNode.nodeType === Node.TEXT_NODE && childNode.textContent.trim()) {
                        const original = childNode.textContent;
                        const transformed = toSentenceCase(original, childNode);
                        if (original !== transformed) {
                            childNode.textContent = transformed;
                        }
                    }
                }
            }
        });
        
        console.log('Sentence case applied to page text and form labels.');
    }
}
